import _ from 'lodash';

export const selectProjectsList = state => _.values(_.get(state, 'projects.data', {}));
export const fetchTotalProjects = state => (state.projects.totalProjects.totalProjects);
export const fetchPageDetails = state => (state.projects.globalPageDetails.pageDetails);
